// extracted by mini-css-extract-plugin
export default {"genericSelect":"GenericStyles_genericSelect__0fjDu","GenericButton":"GenericStyles_GenericButton__wmgKx"};